import { Injectable } from "@angular/core";
import { GalleryService } from "src/app/services/gallery/gallery.service";
import { ConfigService } from "../config/config.service";
import { ContestService } from "../contest/contest.service";

@Injectable({
  providedIn: "root",
})
export class PreloaderService {
  private imagesPath = null;
  private preloadSize;
  private loadedGamesSubcription = null;
  private gameList;
  private prefetchList;
  private preloadImagesList;
  private contestImages = [];
  private readonly CONTESTS_PATH = `${
    this.config?.getConfig()?.CDN_BASEURL
  }/assets/contests/`;

  constructor(
    private galleryService: GalleryService,
    private config: ConfigService,
    private readonly contestService: ContestService
  ) {
    if (this.loadedGamesSubcription) this.unSubcribe();
    this.loadedGamesSubcription = this.galleryService.loadedGames.subscribe(
      (games) => {
        if (games.length > 0) {
          this.preloadSize =
            this.config.getConfig().FEATURE_PRELOADIMAGE_SIZE ?? 20;
          this.loadAndPreloadImagesFromConfig();
          this.gameList = games;
          this.prefetchList = [...this.gameList].slice(0, this.preloadSize);
          try {
            this.preloadImage();
          } catch (e) {}
        }
      }
    );
  }

  preloadImage(): void {
    if (!this.imagesPath)
      this.imagesPath = this.galleryService.getGamesImagePath();
    if (!this.prefetchList) return;

    const combinedList = this.prefetchList
      .map((gameData) => this.imagesPath + gameData.imagename)
      .concat(this.preloadImagesList);
    const loadImagePromises = combinedList.map((imageUrl) =>
      this.loadImageAsync(imageUrl)
    );

    Promise.all(loadImagePromises)
      .then(() => {
        console.log("");
      })
      .catch((error) => {
        console.error("Error preloading images:", error);
      });
    this.preloadContest();
  }

  loadImageAsync(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  loadAndPreloadImagesFromConfig() {
    try {
      const serverResponseJson = this.config.getConfig().FEATURE_PRELOADLIST;

      if (!serverResponseJson) {
        this.useDefaultImages();
        return;
      }

      const parsedResponse = JSON.parse(serverResponseJson);

      if (!parsedResponse?.LIST) {
        this.useDefaultImages();
        return;
      }

      const imageListJson = parsedResponse.LIST;
      if (typeof imageListJson !== "string") {
        this.useDefaultImages();
        return;
      }

      const parsedList = JSON.parse(imageListJson);
      if (!Array.isArray(parsedList)) {
        this.useDefaultImages();
        return;
      }

      this.preloadImagesList = parsedList;
    } catch (error) {
      console.error("Error loading images from config:", error);
      this.useDefaultImages();
    }
  }

  preloadContest() {
    this.contestService.getValidContest().then((contests) => {
      if (contests.length > 0) {
        this.contestImages = contests.map((contest) => {
          return `${this.CONTESTS_PATH}${contest.secondImage}`;
        });
      }
      if (this.contestImages.length > 0) {
        this.contestImages.forEach((imageUrl) => {
          this.loadImageAsync(imageUrl);
        });
      }
    });
  }
  useDefaultImages() {
    this.preloadImagesList = [
      "/main-logo.svg",
      "./assets/images/sd_introanimation2.svg",
    ];
  }

  unSubcribe() {
    try {
      if (this.loadedGamesSubcription) this.loadedGamesSubcription.unSubcribe();
    } catch (e) {
      console.log("Error");
    }
  }
}
